import React, { useState, useRef, useEffect } from "react";
import RightDrawer from "../../../../components/ui/RightDrawer";
import Inputfield from "../../../../components/ui/inputField";
import { ValidatorForm } from "react-material-ui-form-validator";
import axios from "../../../../axios-order";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import Modal from "@mui/material/Modal";
import DownloadIcon from "@mui/icons-material/Download";
import { Grid } from "@material-ui/core";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import MonthWiseDatePicker from "../../../../components/ui/monthWiseDatePicker";
import TextField from "@mui/material/TextField";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { toast } from "react-toastify";
import GSTR1Template from "../../../../asserts/templates/gst_template.xlsx";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshIcon from '@mui/icons-material/Refresh';
import excelIconImage from '../../../../asserts/images/excelicon.svg'

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const GstrSave = () => {
  const form = useRef("form");
  const [username, setUserName] = useState("");
  const [openEstablisConnectionDrawer, setOpenEstablisConnectionDrawer] =
    useState(false);
  const [openOTPModal, setOpenOTPModal] = useState(false);
  const [auth_otp, setAuthOTP] = useState("");
  const [establishConnectionButton, setEstablisConnectionButton] = useState(
    "button-outlined-secondary"
  );
  const [successMessage, setSuccessMessage] = useState("");
  //   get apis data
  const [otpApiData, setOtpApidata] = useState({});
  const [authAPiResData, setAuthApiResData] = useState({});
  const [vyanaList, setVyanaList] = useState([]);
  const [authToken, setAuthToken] = useState("");
  //   file upload section
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [fileUploadData, setFileUploadData] = useState({});
  const [monthWiseDate, setMonthWiseDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorForFileUploadForm, setErrorForFileUploadForm] = useState("");

  const getApiVyanaList = () => {
    axios
      .get(`/vyana/get_list/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data.status === true) {
          setVyanaList(res.data.data);
        } else {
        }
      })
      .catch((error) => {
      });
  };

  useEffect(() => {
    getApiVyanaList();
  }, []);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 300000);

      return () => clearTimeout(timer);
    }
  }, [successMessage]);


  function formatDateTime(datetime) {
    const dateObj = new Date(datetime);

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = dateObj.getFullYear();
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }



  const getOtpForAuthHandler = () => {
    let payload = {
      user_name: username,
      business_entity_id: localStorage.getItem("business_entity_id"),
    };

    axios
      .post("/vyana/send_otp", payload)
      .then((res) => {
        if (res.data.status === true) {
          if (res.data.is_authenticated === true && res.data.is_otp_sent === false) {
            setOpenOTPModal(false);
            if (res.data.message === "Connection established.") {
              setSuccessMessage(res.data.message);
              setAuthToken(res.data.auth_token);
            }
            toast.success(res.data.message, {
              autoClose: 3000,
              progress: 0,
            });
            closeEstablisConnectionDrawerHamdler();
          }
          else if (res.data.is_authenticated === false && res.data.is_otp_sent === true) {
            setOpenOTPModal(true);
            toast.success(res.data.message, {
              autoClose: 3000,
              progress: 0,
            });

          } else {
            setOpenOTPModal(true);
            setOtpApidata({
              ...otpApiData,
              transaction_id: res.data.transaction_id,
              app_key: res.data.app_key,
            });
          }
        } else {
          toast.error(res.data.error, {
            autoClose: 3000,
            progress: 0,
          });
          setOpenOTPModal(false);
          setEstablisConnectionButton("button-outlined-secondary");
        }
      })
      .catch((error) => {
        console.log(error.response.message);
      });
  };


  const closeEstablisConnectionDrawerHamdler = () => {
    setOpenEstablisConnectionDrawer(false);
    setUserName("");
  };

  const vyanaAuthHandler = () => {
    let payload = {
      user_name: username,
      business_entity_id: localStorage.getItem("business_entity_id"),
      app_key: otpApiData.app_key,
      transaction_id: otpApiData.transaction_id,
      otp: auth_otp,
    };

    axios
      .post("/vyana/authenticate", payload)
      .then((res) => {
        if (res.data.status === true) {
          setOpenOTPModal(false);
          setOpenEstablisConnectionDrawer(false);
          setEstablisConnectionButton("button-connection-established");
          setAuthApiResData({
            ...authAPiResData,
            sek: res.data.sek,
            auth_token: res.data.auth_token,
          });
          getApiVyanaList();
          toast.success(res.data.message, {
            autoClose: 3000,
            progress: 0,
          })
          setTimeout(() => {
            setEstablisConnectionButton("button-outlined-secondary");
          }, 300000);
        } else {
          toast.error(res.data.error, {
            autoClose: 3000,
            progress: 0,
          });
          setOpenOTPModal(true);
          setEstablisConnectionButton("button-outlined-secondary");
        }
      })
      .catch((error) => {
        console.log(error.response.message);
        setOpenOTPModal(true);
        setEstablisConnectionButton("button-outlined-secondary");
      });
  };

  const closeOptModalHandler = () => {
    setAuthOTP("");
    setOpenOTPModal(false);
  };

  const fileUploadHandler = (e) => {
    if (e.target.files.length) {
      const uploadedfile = e.target.files[0];
      setUploadedFileName(uploadedfile.name);
      setErrorForFileUploadForm("");
      const reader = new FileReader();
      reader.readAsDataURL(uploadedfile);
      reader.onload = function () {
        let file_value = reader.result;
        setFileUploadData({
          ...fileUploadData,
          file: file_value,
        });
      };
      e.target.value = null;
    }
  };

  const monthwiseDateHandler = (date) => {
    let selectedDate = new Date(date);
    setMonthWiseDate(selectedDate);
    let month = selectedDate.getMonth() + 1;
    let year = selectedDate.getFullYear();
    let formattedMonth = month < 10 ? `0${month}` : month;
    setErrorForFileUploadForm("");
    
    setFileUploadData({
      ...fileUploadData,
      period: `${formattedMonth}${year}`,
    });
  };

  const fileUploadSubmitHandler = () => {
    if (establishConnectionButton === "button-outlined-secondary" && !authToken) {
      return alert("Please establish connection.");
    }

    if (!fileUploadData.file) {
      setLoading(false);
      return setErrorForFileUploadForm("All fields are required.");
    } else if (!fileUploadData.period) {
      setLoading(false);
      return setErrorForFileUploadForm("All fields are required.");
    }

    let payload = {
      ...fileUploadData,
      business_entity_id: localStorage.getItem("business_entity_id"),
      user_name: username,
      transaction_id: otpApiData.transaction_id,
      app_key: otpApiData.app_key,
      sek: authAPiResData.sek,
      auth_token: authAPiResData.auth_token,
    };
    setLoading(true);
    axios
      .post("/vyana/post", payload)
      .then((res) => {
        if (res.data.status === true) {
          setLoading(false);
          setFileUploadData({});
          setUploadedFileName("");
          setMonthWiseDate(null);
          setErrorForFileUploadForm("");
          getApiVyanaList();
        } else {
          setLoading(false);
          getApiVyanaList();
          toast.error(res.data.error, {
            autoClose: 3000,
            progress: 0,
          });
        }
      })
      .catch((error) => {
        console.log(error.response.message);
        setLoading(false);
      });
  };

  const cancelFilUploadFormHandler = () => {
    setFileUploadData({});
    setUploadedFileName("");
    setMonthWiseDate(null);
    setErrorForFileUploadForm("");
    setLoading(false);
  };


  const handleClick = async (reference_no) => {
    try {
      const business_entity_id = localStorage.getItem("business_entity_id");
      const reference_id = reference_no;
      const payload = { business_entity_id, reference_id };
      const response = await axios.post("/vyana/gst_return_status/", payload);


      if (response.data.status === "success") {
        toast.success(response.data.message);
      } else if (response.data.status === "error") {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const downloadBase64File = (contentType, base64Data, fileName) => {
    console.log(contentType, base64Data, fileName);
    const linkSource = `data:${contentType};base64,${base64Data?.split("'")[1]}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const handledownload = (reference_no) => {
    const contentType = "application/json";
    const filename = "GSTR1_Save_Status.json";


    // Prepare payload for the API call
    const business_entity_id = localStorage.getItem("business_entity_id");
    const reference_id = reference_no;
    const payload = { business_entity_id, reference_id };

    // Make the API call using axios
    axios
      .post("/vyana/gst_return_status_download/", payload)
      .then((response) => {
        console.log("API Response:", response.data);
        downloadBase64File(contentType, response.data.records, filename);
      })
      .catch((error) => {
        console.error("Error during API call:", error);
      });
  };

  const downloadBase64Excel = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const handleExcel = (reference_no) => {
    const business_entity_id = localStorage.getItem("business_entity_id");
    const reference_id = reference_no;
    const payload = { business_entity_id, reference_id };
    axios
      .post("/vyana/gst_return_status_download_excel", payload)
      .then((response)=>{
        toast.error(response.data.message)
        const contentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const base64Data = response.data.file;
      if (base64Data) {
        downloadBase64Excel(contentType, base64Data, "GSTR1_Save_Status.xlsx");
      } else {
        console.error("Base64 data is missing in the response");
      }
      })
      .catch((error)=>{
        console.log(error)
      })
  };


  const handleRefresh = (item) => {
    const payloadData = {
      "business_entity_id": localStorage.getItem("business_entity_id"),
      "reference_id": item.reference_no,
      "period": item.period
    }
    axios.post("/vyana/get_gstr_save_updated_status", payloadData)
      .then(() => {
        getApiVyanaList()
      }).catch(() => {

      })
  }



  return (
    <div>
      {/* establish connection for vayana */}
      <div style={{ textAlign: "right" }}>
        <a
          href={GSTR1Template}
          download={"gstr-1template.xlsx"}
          style={{ textDecoration: "none" }}
        >
          <button className="button-primary" type="button">
            Download Template
          </button>
        </a>

        {/* <button
          className={establishConnectionButton}
          onClick={() => setOpenEstablisConnectionDrawer(true)}
        >
          {establishConnectionButton == "button-outlined-secondary"
            ? "Establish Connection"
            : "Connection Established"}
        </button> */}
        {/* <button
    className={establishConnectionButton}
    onClick={() => setOpenEstablisConnectionDrawer(true)}
    
  >
    {successMessage === "Auth token is valid. Please proceed got GSTR1-Save" 
      ? "Connection Established"
      : establishConnectionButton === "button-outlined-secondary"
      ? "Establish Connection"
      : "Connection Established"}
  </button> */}
        {
          successMessage === "Connection established." ? (
            <Button variant="contained" color="success" style={{ fontSize: '13px', padding: '4px 8px', bottom: '4px' }}>
              Connection Established
            </Button>
          ) : (
            <button
              className={establishConnectionButton}
              onClick={() => setOpenEstablisConnectionDrawer(true)}
            >
              {establishConnectionButton === "button-outlined-secondary"
                ? "Establish Connection"
                : "Connection Established"
              }
            </button>
          )
        }

      </div>
      {/*  */}
      <RightDrawer
        drawerName="Establish Connection"
        open={openEstablisConnectionDrawer}
      >
        <ValidatorForm
          ref={form}
          onSubmit={getOtpForAuthHandler}
          onError={(errors) => console.log(errors)}
        >
          <Inputfield
            textLabel="User Name"
            inputType="text"
            name="user_name"
            value={username}
            textOnchangeFunction={(e) => setUserName(e.target.value)}
            requiredField="*"
            validator={["required"]}
            errorMsg={["This field is required"]}
          />
          <div className="mt-20">
            <button className="button-primary" type="submit">
              Submit
            </button>
            <button
              className="button-outlined-secondary"
              type="button"
              onClick={closeEstablisConnectionDrawerHamdler}
            >
              Close
            </button>
          </div>
        </ValidatorForm>
      </RightDrawer>

      <Modal open={openOTPModal}>
        <Box sx={style}>
          <ValidatorForm
            ref={form}
            onSubmit={vyanaAuthHandler}
            onError={(errors) => console.log(errors)}
          >
            <Inputfield
              textLabel="OTP"
              inputType="text"
              name="OTP"
              value={auth_otp}
              textOnchangeFunction={(e) => setAuthOTP(e.target.value)}
              requiredField="*"
              validator={["required"]}
              errorMsg={["This field is required"]}
            />
            <div className="mt-20">
              <button className="button-primary" type="submit">
                Submit
              </button>
              <button
                className="button-outlined-secondary"
                type="button"
                onClick={closeOptModalHandler}
              >
                Close
              </button>
            </div>
          </ValidatorForm>
        </Box>
      </Modal>

      {/*  */}
      <BoxWrapper boxTitle="Upload GSTR-1 File">
        <ValidatorForm
          ref={form}
          onSubmit={fileUploadSubmitHandler}
          onError={(errors) => console.log(errors)}
        >
          <Grid container spacing={3}>
            <Grid item sm={5}>
              <div
                style={{
                  display: "inline-flex",
                  width: "100%",
                  marginTop: "32px",
                }}
              >
                <label
                  className="button-primary"
                  style={{ padding: "7px 15px" }}
                >
                  <input
                    type="file"
                    hidden
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    onChange={(e) => fileUploadHandler(e)}
                  />
                  Upload
                </label>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="eg. cappitallwant.xlsx"
                  variant="standard"
                  InputProps={{
                    readOnly: true,
                  }}
                  value={uploadedFileName}
                  style={{ marginTop: "5px" }}
                />
              </div>
            </Grid>
            <Grid item sm={5}>
              <label>
                Period<span style={{ color: "red" }}>*</span>
              </label>
              <MonthWiseDatePicker
                value={monthWiseDate}
                onChange={(date) => monthwiseDateHandler(date)}
              />
            </Grid>
            <Grid item sm={2}>
              <div style={{ marginTop: "28px" }}>
                {loading ? (
                  <button
                    type="button"
                    className="button-outlined-primary"
                    style={{ padding: "8px 15px" }}
                  >
                    <CircularProgress />
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="button-primary"
                    style={{ padding: "8px 15px" }}
                  >
                    Submit
                  </button>
                )}

                <button
                  type="button"
                  onClick={cancelFilUploadFormHandler}
                  className="button-outlined-secondary"
                  style={{ padding: "8px 15px" }}
                >
                  Cancel
                </button>
              </div>
            </Grid>
          </Grid>
        </ValidatorForm>
        <p style={{ color: "red" }}>{errorForFileUploadForm}</p>
      </BoxWrapper>
      {/*  */}
      <BoxWrapper boxTitle="GSTR-1 Save">
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Period</th>
                <th>Save Date & Time</th>
                <th>Save Status</th>
                <th>Action</th>
                <th>Download Logs</th>
                <th>Download Excel</th>
              </tr>
            </thead>
            <tbody>
              {vyanaList.length >= 1 ? (
                vyanaList.map((v, i) => (
                  <tr key={`${i}vyana`}>
                    <td>{i + 1}</td>
                    <td>{v.period}</td>
                    <td>{formatDateTime(v.create_datetime)}</td>
                    <td>{v.status}</td>
                    <td>
                      {v.status === "Pass" && (
                        <RemoveRedEyeOutlinedIcon
                          className="action-icon-button showIcon"
                          onClick={() =>
                            // alert(`GSTR1 Save Status : ${v.gst_status_response}`)
                            handleClick(v.reference_no)
                          }
                        />
                      )}
                      {v.status === "Fail" && (
                        <RemoveRedEyeOutlinedIcon
                          className="action-icon-button deleteIcon"
                          onClick={() => handleClick(v.reference_no)}
                        />
                      )}

                     {v.status === "Processed with error" && (
                        <RemoveRedEyeOutlinedIcon
                          className="action-icon-button showIcon"
                          onClick={() =>
                            handleClick(v.reference_no)
                          }
                        />
                      )}

                      {v.status === "In-progress" && (
                        <>
                          <RemoveRedEyeOutlinedIcon
                            className="action-icon-button showIcon"
                            onClick={() => handleClick(v.reference_no)}
                          />
                          <RefreshIcon
                            className="action-icon-button refreshIcon"
                            color = "success"
                            onClick={() => handleRefresh(v)}
                            style={{ cursor: "pointer", marginLeft: "8px", color: "orange" }}
                          />
                        </>
                      )}
                    </td>
                    {/* <td><DownloadIcon style={{ cursor: "pointer", color: "blue" }} onClick={() => handledownload(v.reference_no)} /></td>
                    <td><img onClick={() => handleExcel(v.reference_no)} style={{ marginLeft: '5px', height: '23px', width: '25px', cursor: 'pointer' }} src="https://res.cloudinary.com/dkcsi1cmy/image/upload/v1715854976/ohmrrio7mu8yzdzdzrrs.svg" /></td> */}
                    <td>
                      {/* Fix: Check if reference_no is available to enable/disable the buttons */}
                      <DownloadIcon
                        style={{
                          cursor: v.reference_no ? "pointer" : "not-allowed", // Fix: Add disabled cursor
                          color: v.reference_no ? "blue" : "gray", // Fix: Change color when disabled
                        }}
                        onClick={() => v.reference_no && handledownload(v.reference_no)} // Fix: Only trigger download if reference_no is available
                        disabled={!v.reference_no} // Fix: Disable the button if no reference_no
                      />
                    </td>
                    <td>
                      {/* Fix: Check if reference_no is available to enable/disable the Excel download */}
                      <img
                        onClick={() => v.reference_no && handleExcel(v.reference_no)} // Fix: Only trigger download if reference_no is available
                        style={{
                          marginLeft: '5px',
                          height: '23px',
                          width: '25px',
                          cursor: v.reference_no ? 'pointer' : 'not-allowed', // Fix: Add disabled cursor for hover
                          opacity: v.reference_no ? 1 : 0.5, // Fix: Reduce opacity when disabled
                        }}
                        src={excelIconImage}
                        alt="Download Excel"
                        disabled={!v.reference_no} // Fix: Disable the button if no reference_no
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={{ color: "red", textAlign: "center" }} colSpan={5}>
                    No Data Found!
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      </BoxWrapper>
    </div>
  );
};
export default GstrSave;
